import styled from 'styled-components';
export const EmptyBox = styled.div`
  flex: 1;
  margin-inline-start: auto;
  margin-inline-end: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const EmptyBoxIcon = styled.div`
  background: ${({ theme }) => theme.palette.secondarylight};
  width: 186px;
  height: 186px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-bottom: ${({ theme }) => theme.spacing.x8};
`;
export const EmptyBoxTitle = styled.div`
  border-radius: ${({ theme }) => theme.rounded.x3};
  overflow: hidden;
  font-size: ${({ theme }) => theme.fs.xs};
`;
